<script lang="ts">
  import { Component, Vue, Prop } from 'vue-property-decorator';
  import { IRestaurant } from '@/interfaces/IRestaurant';
  import SimpleScrollableModal from '../base/SimpleScrollableModal.vue';
  import ItemsService from '@/api/services/items.service';
  import { IItem } from '@/interfaces/IItem';
  import CategoriesService from '@/api/services/categories.service';
  import RestaurantsService from '@/api/services/restaurants.service';
  import { ICategory } from '@/interfaces/ICategory';
  import { ItemLabelVariables } from '@/const/ItemLabelVariables';

  @Component({
    components: { SimpleScrollableModal },
  })
  export default class StickerSetLabelModal extends Vue {
    @Prop() allItems: IItem[];
    @Prop() baseTemplate?: string;
    $refs!: {
      labelTextarea: any;
    };
    labelTemplate: string = '';
    saving = false;
    variables = ItemLabelVariables.map((v) => v.key);

    async created() {}

    mounted() {
      this.labelTemplate = this.baseTemplate || '';
    }

    save() {
      this.$parent.$emit('submit', this.labelTemplate);
      this.saving = true;
    }

    addVariable(variable: string) {
      const textarea = this.$refs.labelTextarea.$refs
        .input as HTMLTextAreaElement;
      const start = textarea.selectionStart;
      const end = textarea.selectionEnd;
      const text = textarea.value;
      const before = text.substring(0, start);
      const after = text.substring(end, text.length);
      this.labelTemplate = before + '$' + variable + after;
      this.$nextTick(() => {
        textarea.focus();
        textarea.selectionStart = start + variable.length + 1;
        textarea.selectionEnd = start + variable.length + 1;
      });
    }
  }
</script>

<template>
  <simple-scrollable-modal>
    <template #title>
      <h3>Establecer etiqueta</h3>
    </template>
    <template #content>
      <div class="variables mb-4">
        <v-btn
          v-for="variable in variables"
          :key="variable"
          text
          @click="addVariable(variable)"
        >
          ${{ variable }}
        </v-btn>
      </div>
      <v-textarea
        ref="labelTextarea"
        v-model="labelTemplate"
        label="Etiqueta"
        outlined
        dense
        rows="5"
        hide-details
        placeholder="Escriba aquí la etiqueta"
      ></v-textarea
    ></template>
    <template #action-bar>
      <div class="d-flex flex-row justify-end">
        <v-btn
          color="danger"
          text
          depressed
          @click="$emit('close')"
          :disabled="saving"
        >
          Cerrar
        </v-btn>
        <v-btn color="info" depressed @click="save" :loading="saving">
          Guardar
        </v-btn>
      </div>
    </template>
  </simple-scrollable-modal>
</template>

<style scoped lang="scss"></style>
